<script>
import addDays from 'date-fns/addDays';
import DatePicker from 'vue-datepicker-next';
export default {
  components: { DatePicker },
  props: {
    confirmText: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: Date,
      default: null,
    },
    pickerType: {
      type: String,
      default: 'datetime',
      validator: value => ['date', 'datetime'].includes(value),
    },
    format: {
      type: String,
      default: '',
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    disablePast: {
      type: Boolean,
      default: true,
    },
    compact: {
      type: Boolean,
      default: false,
    },
    appendToBody: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['change'],

  methods: {
    handleChange(value) {
      this.$emit('change', value);
    },
    disableBeforeToday(date) {
      const yesterdayDate = addDays(new Date(), -1);
      return date < yesterdayDate;
    },
  },
};
</script>

<template>
  <div class="date-picker">
    <DatePicker
      :type="pickerType"
      confirm
      :append-to-body="appendToBody"
      :show-time-panel="pickerType === 'datetime'"
      :show-second="false"
      :clearable="clearable"
      :editable="false"
      :confirm-text="confirmText"
      :placeholder="placeholder"
      :value="value"
      :format="format || (pickerType === 'date' ? 'DD/MM/YYYY' : undefined)"
      :disabled-date="disablePast ? disableBeforeToday : undefined"
      :input-class="
        compact
          ? 'campaign-date-time-input campaign-date-time-input--compact'
          : 'campaign-date-time-input'
      "
      @change="handleChange"
    />
  </div>
</template>

<style scoped>
:deep(.campaign-date-time-input) {
  @apply !mb-0 h-10 w-full rounded-lg !border-0 !bg-n-alpha-black2 px-3 !pr-10 py-2.5 text-sm text-n-slate-12 shadow-none outline outline-1 outline-offset-[-1px] outline-n-weak transition-colors hover:outline-n-slate-6 focus:outline-n-brand;
}

:deep(.campaign-date-time-input--compact) {
  @apply h-8 py-1.5;
}
</style>
